module.exports = __webpack_public_path__ + "img/hero-banner.8f3d9499.svg";